import { Fragment } from 'react';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { Background } from './components/Background';
import { BanScreen } from './views/BanScreen';

const LayoutComponent = () => (
	<Fragment>
		<Background />
		<BanScreen />
	</Fragment>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.BanScreen)
	.build();

export default Layout;
